export default __webpack_public_path__ + "static/media/ChosainCrossroadsMap.9caa7a66.jpg";